import { useAuth } from '../contexts/AuthContext';
import { useNavigate, NavLink } from 'react-router-dom';
import { formatTime } from '../utils/format';

export default function ProfilePage() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="page-container">
      <div className="row">
        <div className="col-12">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h2><i className="fas fa-user-circle me-2"></i>个人中心</h2>
            <button className="btn btn-outline-secondary" onClick={handleLogout}>
              <i className="fas fa-sign-out-alt me-2"></i>退出登录
            </button>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-8">
          <div className="glass-card mb-4">
            <h4 className="mb-4">基本信息</h4>
            <div className="row mb-4">
              <div className="col-md-4 text-center">
                <div className="avatar-placeholder">
                  <i className="fas fa-user-circle fa-8x text-primary"></i>
                </div>
              </div>
              <div className="col-md-8">
                <table className="table table-borderless">
                  <tbody>
                    <tr>
                      <td className="text-muted" style={{ width: 120 }}>用户名：</td>
                      <td>{user?.username || '-'}</td>
                    </tr>
                    <tr>
                      <td className="text-muted">昵称：</td>
                      <td>{user?.nickname || '-'}</td>
                    </tr>
                    <tr>
                      <td className="text-muted">邮箱：</td>
                      <td>{user?.email || '-'}</td>
                    </tr>
                    <tr>
                      <td className="text-muted">账号类型：</td>
                      <td>
                        {user?.is_admin ? (
                          <span className="badge bg-danger">管理员</span>
                        ) : (
                          <span className="badge bg-primary">普通用户</span>
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td className="text-muted">注册时间：</td>
                      <td>{user?.created_at ? formatTime(user.created_at) : '-'}</td>
                    </tr>
                    <tr>
                      <td className="text-muted">最后登录：</td>
                      <td>{user?.last_login ? formatTime(user.last_login) : '-'}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="glass-card">
            <h4 className="mb-3">账户设置</h4>
            <div className="list-group">
              <div className="list-group-item d-flex justify-content-between align-items-center">
                <div>
                  <i className="fas fa-shield-alt me-2 text-primary"></i>
                  <strong>账户安全</strong>
                  <p className="text-muted small mb-0">管理您的密码和安全设置</p>
                </div>
                <button className="btn btn-outline-primary btn-sm" disabled>即将推出</button>
              </div>
              <div className="list-group-item d-flex justify-content-between align-items-center">
                <div>
                  <i className="fas fa-bell me-2 text-primary"></i>
                  <strong>通知设置</strong>
                  <p className="text-muted small mb-0">配置任务完成通知</p>
                </div>
                <button className="btn btn-outline-primary btn-sm" disabled>即将推出</button>
              </div>
              <div className="list-group-item d-flex justify-content-between align-items-center">
                <div>
                  <i className="fas fa-history me-2 text-primary"></i>
                  <strong>操作日志</strong>
                  <p className="text-muted small mb-0">查看账户操作历史</p>
                </div>
                <button className="btn btn-outline-primary btn-sm" disabled>即将推出</button>
              </div>
            </div>
          </div>
        </div>

        <div className="col-lg-4">
          <div className="glass-card mb-4">
            <h4 className="mb-3">快捷操作</h4>
            <div className="d-grid gap-2">
              <NavLink to="/direct" className="btn btn-primary">
                <i className="fas fa-microphone me-2"></i>直接语音合成
              </NavLink>
              <NavLink to="/submit" className="btn btn-success">
                <i className="fas fa-plus-circle me-2"></i>提交新任务
              </NavLink>
              <NavLink to="/tasks" className="btn btn-info">
                <i className="fas fa-list me-2"></i>查看任务列表
              </NavLink>
            </div>
          </div>

          <div className="glass-card">
            <h4 className="mb-3">系统信息</h4>
            <div className="system-info">
              <div className="info-item">
                <span className="label">版本号：</span>
                <span className="value">v1.0.0</span>
              </div>
              <div className="info-item">
                <span className="label">技术支持：</span>
                <span className="value">科学声响团队</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}